import { URL } from '../constants';
import { opsApiInstance } from '../instance';

import { SendRefundMailRequest, SendCheckoutMailRequest } from './types';

export const sendCheckoutMail = (body: SendCheckoutMailRequest) =>
  opsApiInstance.post(URL.SEND_CHECKOUT_MAIL, body);

export const sendRefundMail = (body: SendRefundMailRequest) =>
  opsApiInstance.post(URL.SEND_REFUND_MAIL, body);
